import actions from "./actions";

const initState = {
    createFieldState: null,
    readFieldListState: null,
    fields: [],
    pagination: {},
    readFieldState: null,
    field: {
        type: 'CONTACT',
        data_type: 'TEXT',
    },
    updateFieldState: null,
    deleteFieldState: null,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
    /* FIELDS */
        case actions.FIELD_SET:
            return {
                ...state,
                field: action.field,
            };
        case actions.FIELD_CREATE_REQUEST:
            return {
                ...state,
                createFieldState: 'request',
            };
        case actions.FIELD_CREATE_SUCCESS:
            return {
                ...state,
                createFieldState: 'success',
            };
        case actions.FIELD_CREATE_FAIL:
            return {
                ...state,
                createFieldState: 'fail',
            };
        case actions.FIELD_READ_LIST_REQUEST:
            return {
                ...state,
                readFieldListState: 'request',
            };
        case actions.FIELD_READ_LIST_SUCCESS:
            return {
                ...state,
                readFieldListState: 'success',
                fields: action.fields,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            };
        case actions.FIELD_READ_LIST_FAIL:
            return {
                ...state,
                readFieldListState: 'fail',
            };
        case actions.FIELD_READ_REQUEST:
            return {
                ...state,
                readFieldState: 'request',
            };
        case actions.FIELD_READ_SUCCESS:
            return {
                ...state,
                readFieldState: 'success',
                field: action.field,
            };
        case actions.FIELD_READ_FAIL:
            return {
                ...state,
                readFieldState: 'fail',
            };
        case actions.FIELD_UPDATE_REQUEST:
            return {
                ...state,
                updateFieldState: 'request',
            };
        case actions.FIELD_UPDATE_SUCCESS:
            return {
                ...state,
                updateFieldState: 'success',
            };
        case actions.FIELD_UPDATE_FAIL:
            return {
                ...state,
                updateFieldState: 'fail',
            };
        case actions.FIELD_DELETE_REQUEST:
            return {
                ...state,
                deleteFieldState: 'request',
            };
        case actions.FIELD_DELETE_SUCCESS:
            return {
                ...state,
                deleteFieldState: 'success',
            };
        case actions.FIELD_DELETE_FAIL:
            return {
                ...state,
                deleteFieldState: 'fail',
            };
            /* OTHERS */
        case actions.FIELD_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
